import React, { useEffect } from 'react';
import { useAuth } from '../hooks/useAuth';

// Composant pour protéger les routes qui nécessitent une authentification
export default function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  useEffect(() => {
    // Si pas en train de charger et pas authentifié, rediriger vers login
    if (!loading && !isAuthenticated()) {
      window.location.href = '/login';
    }
  }, [loading, isAuthenticated]);

  // Afficher un loader pendant la vérification
  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-950 via-black to-slate-950 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-emerald-400 mx-auto mb-4"></div>
          <p className="text-slate-400">Vérification de l'authentification...</p>
        </div>
      </div>
    );
  }

  // Si pas authentifié, ne rien afficher (redirection en cours)
  if (!isAuthenticated()) {
    return null;
  }

  // Si authentifié, afficher le contenu protégé
  return children;
}
